export default __webpack_public_path__ + "static/media/Hind Forge.45097ac0.png";